import { type VideoPreviewResolvedSettings } from '../../../blocs/useVideoPreviewSettings'

export const getCardBackgroundFromSettings = (
  settings: VideoPreviewResolvedSettings
): { color?: string; imageUrl?: string } => {
  return settings.backgroundType === 'image' && settings.backgroundImageUrl
    ? { imageUrl: settings.backgroundImageUrl }
    : { color: settings.backgroundColor }
}
